import { render } from "./MetaverseView.vue?vue&type=template&id=5a38150e&scoped=true"
import script from "./MetaverseView.vue?vue&type=script&lang=js"
export * from "./MetaverseView.vue?vue&type=script&lang=js"

import "./MetaverseView.vue?vue&type=style&index=0&id=5a38150e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a38150e"]])

export default __exports__